module.exports = __webpack_public_path__ + "img/accueil-evenements.0c510dfa.jpg";